import type { AxiosError } from "axios"
import axios from "axios"

import { BASE_URL, KEY_VALUES } from "@/constants"
import { ApiHelper } from "@/utils"
const headers = {
  [KEY_VALUES.ACCEPT_KEY]: KEY_VALUES.ACCEPT_VALUE,
  [KEY_VALUES.CONTENT_TYPE_KEY]: KEY_VALUES.CONTENT_TYPE_VALUE,
}
export const api = axios.create({
  baseURL: BASE_URL,
  headers,
  withCredentials: true,
  timeout: 1000 * 30, // 10 seconds
  validateStatus: (status: number) => ApiHelper.validateStatus(status),
})
const handleError = async (error: AxiosError) => {
  return Promise.reject(ApiHelper.handleError(error))
}
api.interceptors.request.use(ApiHelper.interceptorRequest, handleError)
api.interceptors.response.use(ApiHelper.interceptorResponse, handleError)
